<template>
  <div>
    <v-divider />
    <v-card v-if="patient && trial" flat width="340">
      <v-card-title class="pb-1 pt-2">
        <v-row justify="space-between">
          <v-col cols="10" class="py-0">
            <span
              class="subtitle-2 font-weight-regular"
              :class="{ 'not-viewed': !notification.viewed }"
            >
              Reminder
            </span>
          </v-col>
          <v-col class="py-0">
            <app-icon color="darkTwo" @click="setReminderStatus('read')">clear</app-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="reminder-text" @click="onClick">
        <div class="caption">
          <span :class="{ 'not-viewed': !notification.viewed }">
            Reminder for
            <span @click="setReminderStatus('viewed')"> {{ linkText }}</span>
            {{ noteText }}
          </span>
        </div>
        <div class="timestamp-display" :class="{ 'not-viewed': !notification.viewed }">
          <span>{{ notification.reminderTimestamp | dateFormat('diff') }}</span>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { reminderService } from '@/services/reminder-service'
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import { mapActions } from 'vuex'
import { isFeatureOn } from '@/helpers/feature-flag-helper'

export default {
  props: {
    notification: { type: Object, required: true }
  },
  computed: {
    orgId() {
      return MyActiveOrganization.id
    },
    patient() {
      return this.notification.patientTrial.patient
    },
    trial() {
      return this.notification.patientTrial.organizationTrial.trial
    },
    linkText() {
      return this.patient.externalId
    },
    noteText() {
      if (this.notification.note) {
        return ` | ${this.notification.note}`
      }
      return ''
    },
    trialId() {
      return this.trial.id
    },
    patientId() {
      return this.patient.id
    },
    pcvLinks() {
      return isFeatureOn('pcv-links')
    }
  },
  methods: {
    ...mapActions(['REFRESH_TRIAL_IDENTIFICATIONS', 'REFRESH_REMINDERS']),
    async onClick() {
      await this.setReminderStatus('viewed')
      if (this.pcvLinks) {
        this.$router.push({
          name: 'patient-trial',
          params: {
            orgId: this.orgId,
            patientId: this.patientId,
            trialId: this.trialId
          }
        })
      } else {
        this.$router.push({
          name: 'trial-patient-detail',
          params: { orgId: this.orgId, patientId: this.patientId, trialId: this.trialId }
        })
      }
    },
    async setReminderStatus(status) {
      const params = {
        id: this.notification.id
      }
      params[status] = true
      await reminderService.update(this.notification.id, params)
      this.REFRESH_TRIAL_IDENTIFICATIONS()
      if (status === 'read') {
        this.REFRESH_REMINDERS()
      }
      this.$emit('update')
    }
  }
}
</script>

<style lang="scss" scoped>
.timestamp-display {
  font-size: 8px;
}

.reminder-text {
  cursor: pointer;
}

.not-viewed {
  font-weight: bold !important;
}
</style>
